export const SKIP_QUESTION = 'Skip this question'
